import React from 'react';
import { observer } from 'mobx-react';

import { Form } from 'libs/forms';

import { modalStore } from 'apps/modals/app';
import { Modal } from 'apps/modals/views/modal';
import { ModalTitle } from 'legacyComponents/styled/lib';
import { Trans } from 'react-i18next';
import { ActivationManager } from 'apps/forum/activationForm/appManager';

@observer
export class ActivationForm extends Modal {
  UNSAFE_componentWillMount() {
    this.appManager = new ActivationManager(null, modalStore.props);
  }

  render() {
    const { forumApp } = this.appManager;
    const { form } = forumApp;
    const {
      conf: { formTitle },
    } = form;
    return (
      <>
        <ModalTitle level={2}>
          <Trans>{formTitle}</Trans>
        </ModalTitle>
        <Form
          formStore={form}
          formTitle=''
          buttonHandler={this.appManager.Submit}
          noBorder={true}
          padding='0'
        />
      </>
    );
  }
}
